export const FETCH_USER_INFO_REQUEST = "FETCH_USER_INFO_REQUEST"
export const FETCH_USER_INFO_SUCCESS = "FETCH_USER_INFO_SUCCESS"
export const FETCH_USER_INFO_FAILED = "FETCH_USER_INFO_FAILED"
